import React, { useEffect, useState } from 'react';
import Page from '../components/Page';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { apiEndpoint } from '../prismic-configuration';
import Prismic from '@prismicio/client';
import { Box, Flex, Image, Link, Button } from 'rebass/styled-components';
import CatalogItem from '../components/CatalogItem';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Input, Label } from '../components/Forms';

const ImageBox = styled(Image)`
  padding: 0;
  width: 100%;
  vertical-align: middle;
`;

const Werkkleding = ({ brands, categories, pageContent, lang }) => {
  const createMarkup = (content) => {
    return { __html: content };
  };

  const [brandList, setBrandList] = useState(brands);
  const [loading, setLoading] = useState(false);
  const [activeCategory, setActiveCategory] = useState();
  const [searchTerm, setSearchTerm] = React.useState('');
  const [searchResults, setSearchResults] = React.useState([]);
  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    const results = brandList.filter((brand) =>
      brand.data.name.toLowerCase().includes(searchTerm)
    );
    setSearchResults(results);
  }, [searchTerm]);

  const filterBrands = async (category) => {
    setLoading(true);
    setSearchTerm('');

    let newBrands;
    if (category) {
      setActiveCategory(category.id);
      newBrands = await Prismic.client(apiEndpoint).query([
        Prismic.Predicates.at('document.type', 'brand'),
        Prismic.Predicates.at('my.brand.categories.category', category.id),
      ]);
    } else {
      setActiveCategory(undefined);
      newBrands = await Prismic.client(apiEndpoint).query([
        Prismic.Predicates.at('document.type', 'brand'),
      ]);
    }

    setLoading(false);
    setBrandList(newBrands.results);

    setSearchResults(newBrands.results);
  };

  return (
    <Page
      title='MERLET | Webshop'
      description='Breed assortiment aan bedrijfs- en promotiekledij met
      de mogelijkheid tot personalisatie.'
    >
      <Header />

      <Box width='90%' maxWidth='996px' mx='auto' marginTop={150}>
        <Box maxWidth='792px' pt={4} pb={3} variant='intro'>
          Bekijk hieronder enkele merken uit het aanbod van Merlet.
        </Box>

        <Flex flexWrap='wrap' justifyContent='center'>
          <Button
            sx={{ mr: 10, mb: 10, px: '20px', py: '15px' }}
            onClick={() => filterBrands()}
            variant={!activeCategory ? 'reverse' : 'primary'}
          >
            Toon alle
          </Button>
          {categories &&
            categories.length > 0 &&
            categories.map((category, i) => {
              if (
                category.uid === 'zeefdruk' ||
                category.uid === 'borduur' ||
                category.uid === 'textieltransfer'
              )
                return;
              return (
                <Button
                  sx={{ mr: 10, mb: 10, px: '20px', py: '15px' }}
                  onClick={() => filterBrands(category)}
                  variant={
                    activeCategory === category.id ? 'reverse' : 'primary'
                  }
                >
                  {category.data.name}
                </Button>
              );
            })}
        </Flex>

        <Flex sx={{ mt: 2, justifyContent: 'center', alignItems: 'center' }}>
          <Label sx={{ width: 'auto', mr: 2 }}>Zoek merk op naam: </Label>
          <Input
            id='search'
            name='search'
            variant='footer'
            type='text'
            placeholder='Zoeken...'
            onChange={handleChange}
            value={searchTerm}
            sx={{ width: '300px' }}
          />
        </Flex>

        <Flex flexWrap='wrap' flexDirection='row'>
          {loading ? (
            <Box sx={{ minHeight: 250, pt: 75, mx: 'auto' }}>
              <FontAwesomeIcon icon={faCircleNotch} spin color='#0E2434' />
            </Box>
          ) : searchResults && searchResults.length > 0 ? (
            searchResults.map((merk, i) => {
              console.log(merk);
              // if (merk.type != type) return;
              return (
                <CatalogItem key={i}>
                  <ImageBox
                    src={merk.data.logo.url}
                    alt={merk.data.logo.alt}
                    sx={{
                      position: 'relative',
                      borderStyle: 'solid',
                      borderWidth: '1px',
                      borderColor: 'rgb(214, 185, 133, .4)',
                      '&:hover': {
                        // opacity: 0,
                      },
                    }}
                  ></ImageBox>
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '0',
                      left: '0',
                      padding: 'inherit',
                      opacity: 0.01,
                      '&:hover': {
                        opacity: 1,
                      },
                    }}
                  >
                    {merk.data && merk.data.catalogus_list.length > 0 && (
                      <Link
                        href={merk.data.catalogus_list[0].catalogus_href.url}
                      >
                        <ImageBox
                          src={
                            'https://merletimages.imgix.net/bekijk-catalogus.png'
                          }
                        ></ImageBox>
                      </Link>
                    )}
                  </Box>
                  <Box
                    py='2'
                    variant='title'
                    color='dark'
                    sx={{ textTransform: 'uppercase' }}
                  >
                    {merk.data.name}
                  </Box>
                  <Box>{merk.data.slogan}</Box>
                </CatalogItem>
              );
            })
          ) : (
            <Box
              maxWidth='792px'
              minHeight='250px'
              pt={5}
              pb={6}
              variant='intro'
            >
              Er zijn geen catalogi binnen de gekozen categorie.
            </Box>
          )}
        </Flex>
      </Box>

      <Footer />
    </Page>
  );
};

Werkkleding.getInitialProps = async (context) => {
  const brands = await Prismic.client(apiEndpoint).query(
    [Prismic.Predicates.at('document.type', 'brand')],
    { pageSize: 100 }
  );
  console.log(brands);

  const categories = await Prismic.client(apiEndpoint).query([
    Prismic.Predicates.at('document.type', 'products'),
  ]);

  return { brands: brands.results || [], categories: categories.results || [] };
};

export default Werkkleding;
